import gql from 'graphql-tag';

export const approvePhotoMutation = gql`
  mutation approvePhoto($approvalId: String!) {
    approvePhoto(approvalId: $approvalId)
  }
`;
